// extracted by mini-css-extract-plugin
export default {"toggle":"ToggleSwitch_toggle__wwWlv","toggle--circle":"ToggleSwitch_toggle--circle__Ze3sF","toggle-active":"ToggleSwitch_toggle-active__iOZvE"};